import { DocumentKind, ServiceKind } from "@bitory-gmbh/bsm";
import { CpyName } from "../types/entity-names";

export function CpyNameForDocument(
  serviceKind: ServiceKind,
  dokumentKind: DocumentKind,
): CpyName {
  return `gsm.${serviceKind}.${dokumentKind}`.toLowerCase() as CpyName;
}
